import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { FaShoppingBag, FaExternalLinkAlt } from "react-icons/fa";

interface Product {
  id: string;
  name: string;
  category: string;
  url: string;
  image?: string;
}

const PRODUCTS: Product[] = [
  {
    id: "4367131716",
    name: "Skeleton Filmmaker T-Shirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4367131716/skeleton-filmmaker-midwest-fear-fest",
    image:
      "https://i.etsystatic.com/61228568/r/il/a3a271/7215623038/il_1588xN.7215623038_hq8a.jpg",
  },
  {
    id: "4344537638",
    name: "Poster Print 2025",
    category: "Print",
    url: "https://www.etsy.com/listing/4344537638/midwest-fear-fest-poster-print-2025-mwff",
    image:
      "https://i.etsystatic.com/61228568/r/il/3b7d61/7266127954/il_800x800.7266127954_qwjy.jpg",
  },
  {
    id: "4367136845",
    name: "Retro T-Shirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4367136845/midwest-fear-fest-retro-t-shirt-unisex",
    image:
      "https://i.etsystatic.com/61228568/r/il/f5f60c/7263565975/il_800x800.7263565975_becc.jpg",
  },
  {
    id: "4367133136",
    name: "Static TV Retro T-Shirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4367133136/midwest-fear-fest-static-tv-retro-t",
    image:
      "https://i.etsystatic.com/61228568/r/il/87c8c7/7210925394/il_800x800.7210925394_cswn.jpg",
  },
  {
    id: "4344086137",
    name: "Logo T-Shirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4344086137/midwest-fear-fest-logo-t-shirt-top-mwff",
    image:
      "https://i.etsystatic.com/61228568/r/il/eb2b5c/7210892802/il_800x800.7210892802_41o2.jpg",
  },
  {
    id: "4367137381",
    name: "International Film Festival T-Shirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4367137381/midwest-fear-fest-international-film",
    image:
      "https://i.etsystatic.com/61228568/r/il/3ed6e4/7215599280/il_800x800.7215599280_skh1.jpg",
  },
  {
    id: "4367132196",
    name: "International Film Festival Hoodie",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4367132196/midwest-fear-fest-international-film",
    image:
      "https://i.etsystatic.com/61228568/r/il/8f0ca4/7187571016/il_800x800.7187571016_ruqw.jpg",
  },
  {
    id: "4344535083",
    name: "Retro Zombie Sticker",
    category: "Sticker",
    url: "https://www.etsy.com/listing/4344535083/midwest-fear-fest-retro-zombie-sticker",
    image:
      "https://i.etsystatic.com/61228568/r/il/497842/7139832085/il_800x800.7139832085_dxz8.jpg",
  },
  {
    id: "4348531608",
    name: "Logo Sticker / Magnet",
    category: "Sticker",
    url: "https://www.etsy.com/listing/4348531608/midwest-fear-fest-logo-sticker-or-magnet",
    image:
      "https://i.etsystatic.com/61228568/r/il/279b50/7196297241/il_800x800.7196297241_3zdg.jpg",
  },
  {
    id: "4344361795",
    name: "Logo Black Coffee Mug",
    category: "Drinkware",
    url: "https://www.etsy.com/listing/4344361795/midwest-fear-fest-logo-black-coffee-mug",
    image:
      "https://i.etsystatic.com/61228568/r/il/461f64/7117150159/il_800x800.7117150159_nlvj.jpg",
  },
  {
    id: "4344365395",
    name: "Logo Insulated Tumbler",
    category: "Drinkware",
    url: "https://www.etsy.com/listing/4344365395/midwest-fear-fest-logo-insulated-tumbler",
    image:
      "https://i.etsystatic.com/61228568/r/il/443abb/7117176765/il_800x800.7117176765_mijm.jpg",
  },
  {
    id: "4344134745",
    name: "Logo Crewneck Sweatshirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4344134745/midwest-fear-fest-logo-crewneck",
    image:
      "https://i.etsystatic.com/61228568/r/il/1df516/7117161463/il_800x800.7117161463_4a8c.jpg",
  },
  {
    id: "4344122225",
    name: "Logo Long Sleeve Shirt",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4344122225/midwest-fear-fest-logo-long-sleeve-shirt",
    image:
      "https://i.etsystatic.com/61228568/r/il/b6c581/7069172750/il_800x800.7069172750_cd88.jpg",
  },
  {
    id: "4344121687",
    name: "Logo Hoodie",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4344121687/midwest-fear-fest-logo-hoodie-mwff",
    image:
      "https://i.etsystatic.com/61228568/r/il/73461d/7117081933/il_800x800.7117081933_d5m5.jpg",
  },
  {
    id: "4344531342",
    name: "Killer Alien Static TV Sticker",
    category: "Sticker",
    url: "https://www.etsy.com/listing/4344531342/midwest-fear-fest-killer-alien-static-tv",
    image:
      "https://i.etsystatic.com/61228568/r/il/dd8a3e/7139792345/il_800x800.7139792345_8hvg.jpg",
  },
  {
    id: "4344538218",
    name: "Inaugural Poster Print",
    category: "Print",
    url: "https://www.etsy.com/listing/4344538218/inaugural-midwest-fear-fest-poster-print",
    image:
      "https://i.etsystatic.com/61228568/r/il/8aa506/7316739235/il_800x800.7316739235_l6i3.jpg",
  },
  {
    id: "4344547801",
    name: "Embroidered Baseball Cap",
    category: "Apparel",
    url: "https://www.etsy.com/listing/4344547801/midwest-fear-fest-embroidered-baseball",
    image:
      "https://i.etsystatic.com/61228568/r/il/43cef3/7118142057/il_800x800.7118142057_sh3c.jpg",
  },
];

const CATEGORY_COLOR: Record<string, string> = {
  Print: "#cc0000",
  Apparel: "#8844cc",
  Sticker: "#cc6600",
  Drinkware: "#008888",
};

export default function Shop() {
  const ref = useScrollAnimation();

  return (
    <section
      id="shop"
      style={{
        background: "#0d0d12",
        padding: "clamp(64px,10vw,120px) clamp(20px,5vw,80px)",
      }}
    >
      <div ref={ref} style={{ maxWidth: "1200px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ marginBottom: "56px", textAlign: "center" }}>
          <div
            className="section-label animate-on-scroll"
            style={{ justifyContent: "center", marginBottom: "16px" }}
          >
            Official Merch
          </div>
          <h2
            className="display-heading animate-on-scroll"
            style={{
              fontSize: "clamp(2.5rem,6vw,4.5rem)",
              color: "#e8e8e8",
              transitionDelay: "100ms",
            }}
          >
            The <span style={{ color: "#cc0000" }}>Shop</span>
          </h2>
          <p
            className="animate-on-scroll"
            style={{
              color: "rgba(232,232,232,0.6)",
              fontSize: "0.95rem",
              marginTop: "16px",
              transitionDelay: "150ms",
              maxWidth: "480px",
              margin: "16px auto 0",
            }}
          >
            Rep the fest. Official Midwest Fear Fest gear designed by local artists and available now on Etsy, with all proceeds supporting the festival and independent filmmakers.
          </p>
        </div>

        {/* Product Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: "24px",
          }}
        >
          {PRODUCTS.map((product, i) => (
            <a
              key={product.id}
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              className="animate-on-scroll"
              style={{
                textDecoration: "none",
                display: "flex",
                flexDirection: "column",
                borderRadius: "12px",
                overflow: "hidden",
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.07)",
                // Note: transition-delay is set here for the appear animation.
                // Hover transitions (border-color, transform) are handled via
                // onMouseEnter/Leave so they're unaffected by this delay.
                transitionDelay: `${Math.min(i * 40, 400)}ms`,
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLAnchorElement;
                // Clear the stagger delay so hover responds immediately.
                el.style.transitionDelay = "0ms";
                el.style.borderColor = "rgba(204,0,0,0.45)";
                el.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLAnchorElement;
                el.style.transitionDelay = "0ms";
                el.style.borderColor = "rgba(255,255,255,0.07)";
                el.style.transform = "translateY(0)";
              }}
            >
              {/* Image area */}
              <div
                style={{
                  aspectRatio: "1 / 1",
                  background: product.image
                    ? `url(${product.image}) center/cover`
                    : "linear-gradient(135deg, #1a1a22 0%, #0f0f18 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {!product.image && (
                  <span
                    className="display-heading"
                    style={{
                      fontSize: "2.5rem",
                      color: "rgba(204,0,0,0.25)",
                      letterSpacing: "0.08em",
                      userSelect: "none",
                    }}
                  >
                    MWFF
                  </span>
                )}
                {/* Category badge */}
                <span
                  style={{
                    position: "absolute",
                    top: "12px",
                    left: "12px",
                    fontFamily: '"Bebas Neue", cursive',
                    fontSize: "0.65rem",
                    letterSpacing: "0.2em",
                    color: "#fff",
                    background: CATEGORY_COLOR[product.category] ?? "#cc0000",
                    padding: "3px 8px",
                    borderRadius: "4px",
                  }}
                >
                  {product.category}
                </span>
              </div>

              {/* Info */}
              <div
                style={{
                  padding: "16px 20px 20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  flexGrow: 1,
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#e8e8e8",
                    fontSize: "0.92rem",
                    fontWeight: 500,
                    lineHeight: 1.4,
                  }}
                >
                  {product.name}
                </p>

                <span
                  style={{
                    marginTop: "auto",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "0.75rem",
                    letterSpacing: "0.12em",
                    color: "#cc0000",
                    fontFamily: '"Bebas Neue", cursive',
                  }}
                >
                  Shop on Etsy
                  <FaExternalLinkAlt style={{ fontSize: "0.6rem" }} />
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* View All CTA */}
        <div
          className="animate-on-scroll"
          style={{ textAlign: "center", marginTop: "48px" }}
        >
          <a
            href="https://www.etsy.com/shop/MidwestFearFest"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{
              fontSize: "1rem",
              padding: "14px 40px",
              textDecoration: "none",
            }}
          >
            <FaShoppingBag style={{ fontSize: "0.9em" }} />
            View Full Shop on Etsy
          </a>
        </div>
      </div>
    </section>
  );
}
